<script setup>
import { computed } from 'vue';

const props = defineProps({ 
  pagetype: {
    type: String,
    default: '',
  },  
  tableData: {
    type: Array,
    default: () => [
      { label: '전체학교', schoolCount: '', classCount: '', studentCount: '', male: '', female: '' },
      { label: '우리학교', schoolCount: '', classCount: '3', studentCount: '', male: '', female: '' },
    ],
  },
});
</script>

<template>
  <div class="exam-status" :class="props.pagetype">    
    <p class="text-[22px] pt-5 pb-[14px] font-medium text-center">응시현황</p>
    <table>
      <colgroup>
        <col style="width:auto" />
        <col style="width:16.5%" />
        <col style="width:16.5%" />
        <col style="width:16.5%" />
        <col style="width:16.5%" />
        <col style="width:16.5%" />
      </colgroup>
      <thead>
        <tr>
          <th rowspan="2">구분</th>
          <th colspan="3">응시현황</th>
          <th colspan="2">성별</th>
        </tr>
        <tr>
          <th>학교 수(교)</th>
          <th>학급 수(학급)</th>
          <th>학생 수(명)</th>
          <th>남학생</th>
          <th>여학생</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in tableData" :key="index">
          <td>{{ row.label }}</td>
          <td>{{ row.schoolCount }}</td>
          <td>{{ row.classCount }}</td>
          <td>{{ row.studentCount }}</td>
          <td>{{ row.male }}</td>
          <td>{{ row.female }}</td>
        </tr>
        <!-- 데이터가 없을 경우 -->
        <tr v-if="!tableData || tableData.length === 0">
          <td colspan="6" class="text-center">데이터가 없습니다.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.exam-status {
    table {
        text-align: center;
        th {
            height: 40px;
            font-weight: 400;
        }
        td {
            height: 50px;
        }
        tr:nth-child(2) td {background-color: rgba(0, 164, 150, .05);}
    }
    &.literacy {
        table tr th {background-color: #F0F3FE;}
    }
    &.numeracy {
        table tr th {background-color: #FEE6E7;}
    }
}
</style>